<template>
  <div id="online-data"
       class="home container-fluid">

    <transition name="fade"
                mode="out-in">
      <div v-if="!showPreview"
           class="panel mb-3">

        <div class="row mb-2">
          <div class="col-xs-12 col-md-5">
            <small>{{ $t('#TR-total-sum') }}</small>:
            <span class="font-weight-bold">
              {{ totalSum }}
            </span>
          </div>

          <div class="col-xs-12 col-md-7">

            <button class="btn btn-success ml-3 float-right"
                    @click="refreshOrders">
              <span class="mdi mdi-refresh"></span>
              <span class="d-none d-md-inline">{{ $t('#TR-refresh')}}</span>
            </button>

            <b-form-checkbox switch
                             class="float-md-right float-none"
                             size="lg"
                             :checked="onlyOnline"
                             @change="changeOnlyOnline">
              <!-- <span :class="{
                      'text-success': !onlyOnline,
                      'small': onlyOnline
                    }"
                    class="small">
                {{ $t('#TR-all') }}
              </span> /-->
              <span :class="{ 'text-success': onlyOnline}"
                    style="font-size: 14px !important">
                {{ $t('#TR-opened') }}
              </span>
            </b-form-checkbox>

          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <table-orders v-if="tableView"
                          :orders="orders"
                          @onprevieworder="onPreviewOrder" />

            <tile-orders v-else
                         :orders="displayedOrders"
                         @onprevieworder="onPreviewOrder" />
          </div>
        </div>
      </div>
    </transition>

    <pagination v-if="orders && !showPreview"
                ref="pagination"
                :total-count="orderRows"
                :per-page="perPage"
                @changePage="changePage">
    </pagination>

    <transition name="fade"
                mode="out-in">
      <div v-if="showPreview"
           class="position-relative">
        <order-view :order="viewOrder"
                    @close="onClosePreview" />
      </div>
    </transition>
    <main-loader></main-loader>
  </div>
</template>

<script>
  import { ApiOnlineData } from '@/services/api';
  import MSG from '@/services/notify';
  import MainLoader from '@/components/Loader';
  import Pagination from '@/components/Pagination';
  import OrderView from '@/views/OnlineData/Order';
  import TableOrders from '@/views/OnlineData/TableOrders';
  import TileOrders from '@/views/OnlineData/TileOrders';

  export default {
    name: 'Orders',

    components: {
      TableOrders,
      TileOrders,
      MainLoader,
      Pagination,
      OrderView
    },

    data() {
      return {
        tableView: false,

        showPreview: false,
        midId: this.$route.params.mid,
        orders: [],
        selectedOrder: null,
        viewOrder: null,

        totalSum: 0,

        perPage: 15,
        fromPage: 1
      };
    },

    computed: {
      orderRows() {
        return this.orders.length;
      },

      onlyOnline() {
        return this.$store.state.orderOnlyOnline;
      },

      displayedOrders() {
        return this.paginate(this.orders);
      }
    },

    created() {
      this.$store.commit('setPageTitle', this.$t('#TR-online-data'));
      this.getOrders();
    },

    methods: {
      changeOnlyOnline() {
        this.$store.commit('toggleOrderOnlyOnline');
        this.getOrders();
        this.refreshOrders();
      },

      refreshOrders() {
        this.getOrders();
        this.changePage(1);
        if (this.$refs.pagination) {
          this.$refs.pagination.setPage();
        }
      },

      getOrders: async function () {
        this.$store.commit('toggleLoader', true);
        const result = await ApiOnlineData.orders(this.midId, this.onlyOnline);
        this.$store.commit('toggleLoader', false);

        if (!result.error) {
          this.orders = result.data;

          let sum = 0;
          this.orders.forEach(item => {
            sum = sum + parseInt(item.orderSum);
          });

          this.totalSum = sum / 100;

        } else {
          MSG.error(result.error, this);
        }
      },

      async onPreviewOrder(order) {
        this.showPreview = true;
        this.$store.commit('toggleLoader', true);
        const result = await ApiOnlineData.order(this.midId, order.guid);
        this.$store.commit('toggleLoader', false);
        if (!result.error) {
          this.viewOrder = result.data;
          this.selectedOrder = order;
        } else {
          MSG.error(result.error, this);
        }
      },

      onClosePreview() {
        this.viewOrder = null;
        this.showPreview = false;
        this.selectedOrder = null;
      },

      paginate(orders) {
        const to = (this.fromPage + this.perPage) - 1;

        this.$nextTick(() => {
          const elem = document.getElementById('main-content');
          elem.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        });

        return orders.slice(this.fromPage - 1, to);
      },

      changePage(from) {
        this.fromPage = from;
      }
    }
  };
</script>

<style lang="stylus" scoped>

#online-data {
  position: relative
  min-height: 100%;
}



</style>
